<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} thông báo hệ thống</h1>

          <div style="float: right">
            <button
              type="button"
              @click="$router.push('/system-notification')"
              class="btn btn-light"
            >
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="" vid="applyFor" name="Mã danh mục Ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Nội dung </label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.content" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="startedTime.startDate" name="Ngày bắt đầu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Ngày bắt đầu<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <DateRangePicker
                      class="w-100"
                      :ranges="false"
                      :show-week-numbers="false"
                      :single-date-picker="true"
                      v-model="dataRequest.startedTime"
                      :locale-data="Config.localeData"
                      :timePicker="true"
                      :timePicker24Hour="true"
                    >
                      <template v-slot:input="picker">
                        {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY') }}
                      </template>
                    </DateRangePicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="endedTime.startDate" name="Ngày kết thúc">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Ngày kết thúc<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <DateRangePicker
                      class="w-100"
                      :ranges="false"
                      :show-week-numbers="false"
                      :single-date-picker="true"
                      v-model="dataRequest.endedTime"
                      :locale-data="Config.localeData"
                      :timePicker="true"
                      :timePicker24Hour="true"
                    >
                      <template v-slot:input="picker">
                        {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY') }}
                      </template>
                    </DateRangePicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="code" name="Link tài liệu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Link tài liệu<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model.trim="dataRequest.link" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="name" name="Link nhóm hỗ trợ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Link nhóm hỗ trợ<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="dataRequest.linkSupport"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="subjects" name="Quyền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Quyền</label>
                  <div class="col-sm-9">
                    <Select2MultipleControl
                      :settings="{ closeOnSelect: false }"
                      v-model="dataRequest.subjects"
                      :options="optionsSubjects"
                    >
                    </Select2MultipleControl>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { NotificationService } from '@/services/notification.service'
  import cloneDeep from 'lodash/cloneDeep'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  export default {
    name: 'system-notification',
    data() {
      return {
        Config,
        dataRequest: {
          startedTime: {},
          endedTime: {},
        },
        optionsSubjects: [...Config.listTypeSale, { id: 'ALL', text: 'Tất cả' }],
        showLoading: false,
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.dataRequest)
        data.endedTime = moment(data.endedTime.startDate).valueOf()
        data.startedTime = moment(data.startedTime.startDate).valueOf()
        return data
      },
      async submitRequest() {
        try {
          this.showLoading = true
          const params = this.preareData()
          if (this.dataRequest.id) {
            const response = await NotificationService.updateNotifySystem(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật thông báo hệ thống thành công').then(() =>
                this.$router.push('/system-notification')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await NotificationService.createNotifySystem(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới thông báo hệ thống thành công').then(() =>
                this.$router.push('/system-notification')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        const id = this.$route.params.id
        if (id) {
          try {
            this.showLoading = true
            const responsive = await NotificationService.detailNotifySystem({ id })
            this.dataRequest = responsive.data
            this.dataRequest.startedTime = {
              startDate: moment(responsive.data.startedTime).valueOf(),
              endDate: moment(responsive.data.startedTime).valueOf(),
            }
            this.dataRequest.endedTime = {
              startDate: moment(responsive.data.endedTime).valueOf(),
              endDate: moment(responsive.data.endedTime).valueOf(),
            }
            console.log(this.dataRequest)
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
